<template>
    <div class="content-i">
        <div class="content-box">
            <div class="row justify-content-center">
              <div v-if="exibeMsgSucesso" class="col">
                <div class="element-wrapper">
                  <h6 class="element-header">
                    Cadastro Realizado Com Sucesso
                  </h6>
                  <div class="element-box">
                    <div class="col-md-6 offset-md-3">
                      <h5 class="form-head">Parabéns {{ nomeCliente }}. Seu cadastro foi realizado com sucesso!</h5>
                      <div class="form-desc">
                        Agora você pode Adquirir e agendar suas consultas e ou exames diretamente pelo Site.
                      </div>
                      <div class="col text-center">
                        <i class="fas fa-check-circle fa-7x" style="color: green"></i>
                      </div>
                      <div class="col text-center">
                        <router-link :to="{name: 'Home'}" class="btn btn-primary btn-lg" role="button">Login</router-link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="col">
                <div class="element-wrapper">
                  <h6 class="element-header">
                    Defina Seus dados de acesso
                  </h6>
                  <div class="element-box">
                    <div class="col-md-6 offset-md-3">
                      <form @submit.prevent="salvar">
                        <h5 class="form-head">
                            Olá, {{ cliente.name }}. Defina os dados de acesso para o site Dr.Achei
                        </h5>
                        <div class="form-desc">
                            Lembre-se seus dados de acesso é de uso pessoal e instransferível.
                        </div>

                        <div class="form-row">
                          <div class="form-group col-md-6">
                            <div class="form-group">
                              <label for="email">Email</label>
                              <input type="email" name="email" id="email"
                                v-model="payload.email" required
                                class="form-control" aria-describedby="helpId">
                            </div>
                          </div>
                          <div class="form-group col-md-6">
                            <div class="form-group">
                              <label for="celular">Celular</label>
                              <input type="tel" name="celular" id="celular"
                                v-model="payload.telefoneCelular" required
                                v-mask="['(##) ####-####', '(##) #####-####']"
                                class="form-control" aria-describedby="helpId">
                            </div>
                          </div>
                        </div>
                        <div class="form-row">
                          <div class="form-group col">
                            <label for="username">Usuario</label>
                              <input type="text" name="username" id="username"
                                v-model="payload.username" required
                                class="form-control" aria-describedby="helpId">
                          </div>
                        </div>
                        <div class="form-row">
                          <div class="form-group col">
                            <label for="senha">Senha</label>
                              <input type="password" name="senha" id="senha"
                                v-model="payload.password" required
                                class="form-control" aria-describedby="helpId">
                          </div>
                        </div>
                        <div class="form-row">
                          <div class="form-group col">
                            <label for="repeteSenha">Repetir Senha</label>
                              <input type="password" name="repeteSenha" id="repeteSenha"
                                v-model="repeteSenha" required
                                class="form-control" aria-describedby="helpId">
                          </div>
                        </div>

                        <div class="form-buttons-w">
                            <button type="button" class="btn btn-secondary" @click="goToSinSaude">Voltar</button>
                            <button type="submit" class="btn btn-primary">Salvar</button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  computed: {
    cliente () {
      return this.$store.getters.cartao ? this.$store.getters.cartao.pedido.client : null
    }
  },
  created () {
    if (!this.$store.getters.cartao) {
      this.$router.push({name: 'Cadastrese-pergunta'})
    }
  },
  data () {
    return {
      nomeCliente: null,
      exibeMsgSucesso: false,
      repeteSenha: null,
      payload: {
        email: null,
        telefoneCelular: null,
        username: null,
        password: null
      }
    }
  },
  methods: {
    goToSinSaude () {
      this.clear()
      this.$router.push({name: 'Cadastrese-sinsaude'})
    },
    clear () {
      this.payload = {
        email: null,
        telefoneCelular: null,
        username: null,
        password: null
      }
      this.repeteSenha = null
    },
    salvar () {
      if (this.repeteSenha === this.payload.password) {
        this.payload.cartao = this.$store.getters.cartao
        this.nomeCliente = this.cliente.nome

        this.$store.dispatch('salvaCartaoSinsaude', this.payload)
          .then(() => {
            this.clear()
            this.exibeMsgSucesso = true
            this.$store.dispatch('setNomeUsuario', this.nomeCliente)
            this.$router.push({name: 'Cadastrese-sucesso'})
          })
      } else {
        this.$toasted.show('As senhas não correspondem', {
          icon: { name: 'fa-exclamation-triangle' },
          type: 'error',
          theme: 'bubble',
          action: {
            text: 'FECHAR',
            onClick: (e, toastObject) => {
              toastObject.goAway(0)
            }
          }
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/cadastrese/Usuario.vue